export class SourceOfWealthData {
    private sources: Array<string> = [
        'Property',
        'Interest',
        'Disability',
        'Market trading profits',
        'Inheritance',
        'Pension',
        'Allowance \ Spouse gift',
        'Other Sources'];

    public incomeSourceList = [
        { id: 0, name: 'Income from Employment' },
        { id: 1, name: 'Disability / Severance / Unemployment' },
        { id: 2, name: 'Inheritance / Gift' },
        { id: 3, name: 'Interest / Dividend Income' },
        { id: 5, name: 'Pension / Government Retirement benefit' },
        { id: 6, name: 'Property' },
        { id: 7, name: 'Allowance / Spousal Income' },
        { id: 8, name: 'Other' }
    ];

    public getSourceList(): Array<string> {
        return this.sources;
    }
}
